// Decks: accesos directos a los decks vivos del vertical. Sus números y
// supuestos también viven como páginas `deck` del cerebro (el seed las carga),
// así que Preguntar puede citarlos.

import { ExternalLink, FileDown } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'

interface DeckLink {
  title: string
  description: string
  href: string
  pdf?: string
  brainSlug?: string
  badges: string[]
}

const DECKS: DeckLink[] = [
  {
    title: 'Vertical In-Person Payments (C-Level)',
    description: '11 slides · el pitch de la vertical: desbloqueo BanCoppel, $2.4M ARR, calendario Q4\'26→Q3\'27, el pedido de VP.',
    href: '/in-person-payments',
    pdf: '/in-person-payments/pdf',
    brainSlug: 'decks/in-person-payments',
    badges: ['es', 'en'],
  },
  {
    title: 'BC BanCoppel — MDR',
    description: '6 slides · MDR 1.70% → 1.50% sobre 6M tx/mes vs pricing escalonado de Yuno.',
    href: '/bc-bancoppel',
    pdf: '/bc-bancoppel/pdf',
    brainSlug: 'decks/bc-bancoppel-mdr',
    badges: ['es'],
  },
  {
    title: 'Propuesta BanCoppel 2027',
    description: '11 slides · tramos $0.210 → piso $0.18 MXN/tx (1 centavo USD desde 4M tx) + licencia SaaS $20K USD/mes + fee de implementación ($50K USD con SDK en terminal, $0 back-to-back) + mínimo transaccional (1M en mar-2027, +500K/mes, techo 4M) + caso de negocio (MDR 1.60% → 1.45% + aprobación 94% → 96%).',
    href: '/propuesta-bancoppel',
    pdf: '/propuesta-bancoppel/pdf',
    brainSlug: 'decks/propuesta-bancoppel-2027',
    badges: ['es'],
  },
  {
    title: 'Propuesta Grupo Quálitas',
    description: '3 slides · fee fijo + tx exitosa con mínimo mensual.',
    href: '/qualitas',
    pdf: '/qualitas/pdf',
    brainSlug: 'decks/propuesta-qualitas',
    badges: ['es'],
  },
]

interface Props {
  onOpenPage: (slug: string) => void
}

export function DecksTab({ onOpenPage }: Props) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Los decks del vertical. Sus números y supuestos también son páginas del cerebro — en
        Preguntar puedes citar “¿cuál es la rampa del deal?” y la respuesta viene con la fuente.
      </p>
      <div className="grid gap-3 md:grid-cols-2">
        {DECKS.map((deck) => (
          <Card key={deck.href} className="flex flex-col gap-2 p-4">
            <div className="flex items-start justify-between gap-2">
              <span className="font-heading text-base font-semibold">{deck.title}</span>
              <div className="flex gap-1">
                {deck.badges.map((b) => (
                  <Badge key={b} variant="outline" className="uppercase">{b}</Badge>
                ))}
              </div>
            </div>
            <p className="text-sm text-muted-foreground">{deck.description}</p>
            <div className="mt-auto flex items-center gap-3 pt-2 text-sm">
              <a
                href={deck.href}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1 text-primary hover:underline"
              >
                <ExternalLink className="h-3.5 w-3.5" /> Ver deck
              </a>
              {deck.pdf && (
                <a
                  href={deck.pdf}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-muted-foreground hover:underline"
                >
                  <FileDown className="h-3.5 w-3.5" /> Versión imprimible
                </a>
              )}
              {deck.brainSlug && (
                <button
                  type="button"
                  onClick={() => onOpenPage(deck.brainSlug!)}
                  className="ml-auto font-mono text-xs text-teal-600 hover:underline dark:text-teal-400"
                >
                  ver en el cerebro
                </button>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}
